import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  admin: null,
  token: null,
  isAuthenticated: false
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {

    setAdmin: (state, action) => {
      state.admin = action.payload;
      state.isAuthenticated = true;
    },

    setToken: (state, action) => {
      state.token = action.payload;
    },

    logout: (state) => {
      state.admin = null;
      state.token = null;
      state.isAuthenticated = false;
    }

  }
});

export const { setAdmin, setToken, logout } = authSlice.actions;

export default authSlice.reducer;